import { render } from "./CommonImg.vue?vue&type=template&id=52a7c9d8&scoped=true"
import script from "./CommonImg.vue?vue&type=script&lang=js"
export * from "./CommonImg.vue?vue&type=script&lang=js"

import "./CommonImg.vue?vue&type=style&index=0&id=52a7c9d8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a7c9d8"]])

export default __exports__